export default __webpack_public_path__ + "static/media/image3D.c23e2123.jpg";